module.exports = __webpack_public_path__ + "img/chest.631258d1.png";